import { Directive, ElementRef, HostBinding, Inject, Renderer2 } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { addClass, setAttr, setCSS } from '@wm/core';

import { DialogRef } from '@wm/components/base';

declare const $;

const DEFAULT_CLS = 'app-dialog-body modal-body';

@Directive({
    selector: 'div[wmDialogBody]',
})
export class DialogBodyDirective {
    @HostBinding('style.height') height;
    constructor(
        elRef: ElementRef,
        @Inject(DialogRef) private dialogRef,
        bsModal: BsModalService,
         private renderer: Renderer2
    ) {
        addClass(elRef.nativeElement, DEFAULT_CLS);

        const subscription = bsModal.onShown.subscribe(() => {
            // const wmAppWrapper = this.renderer.createElement('div');
            // addClass(wmAppWrapper, 'wm-app');

            $('body > modal-container').wrap('<div class="wm-app-dynamic-wrapper"> </div>');
            const dialogRoot = $(elRef.nativeElement).closest('.app-dialog')[0];
            const dialogRootContainer = $(elRef.nativeElement).closest('.wm-app-dynamic-wrapper')[0];
            const dialogBackrop = $(elRef.nativeElement).parents().find('.modal-backdrop')[0];
            const parentContainer = $(elRef.nativeElement).parents().find(".modal")[0];
            // if(dialogRootContainer){
            //     // addClass(dialogRootContainer, 'wm-app');
            // }
            if(dialogBackrop){
                
                this.renderer.insertBefore(dialogRootContainer, dialogBackrop, parentContainer);
            //     this.renderer.appendChild(wmAppWrapper, dialogRootContainer);
            //     this.renderer.appendChild(parentContainer, wmAppWrapper);
            //    // addClass(dialogBackrop, 'wm-app');
            }
            const width = this.dialogRef.width;
            const height = this.dialogRef.height;
            if(height){
               setTimeout(e=>{
                    setCSS($(elRef.nativeElement)[0], 'height', height);
                });
            }      
            if (dialogRoot) {
                if (width) {
                    setCSS(dialogRoot, 'width', width);
                }
                setAttr(dialogRoot, 'tabindex', this.dialogRef.tabindex);
                setAttr(dialogRoot, 'name', this.dialogRef.name);

            }
            subscription.unsubscribe();
        });
    }
}
